export default __webpack_public_path__ + "c5488dc2a363d1d15e7a60287bc098c5.svg";